// extracted by mini-css-extract-plugin
export var formSection = "DesktopEmbed-module--formSection--bc873";
export var inputContainer = "DesktopEmbed-module--inputContainer--43b40";
export var inputWrapperDefault = "DesktopEmbed-module--inputWrapperDefault--5c3dc";
export var splitContainer = "DesktopEmbed-module--splitContainer--99a42";
export var splitSubmit = "DesktopEmbed-module--splitSubmit--66d04";